module.exports = __webpack_public_path__ + "static/media/airplane-travel.452b1f1a.jpg";